import { Button, Sidebar, TextArea } from 'components/common';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { addInterventionStep } from 'features/material/services/interventionServices';
import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

interface NewActionInterventionProps {
  id: number;
  refetchIntervention?: () => void;
}

const NewActionIntervention: FC<SideBarProps<NewActionInterventionProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();

  const handleAddStep = async (values: {
    id: number;
    user_Id?: number;
    step?: string;
    description?: string;
  }) => {
    const res = await addInterventionStep(values);
    if (res.success) {
      toast.success(res.message);
      params?.refetchIntervention?.();
      closeSidebar(NewActionIntervention);
    } else {
      toast.error(res.message);
    }
  };

  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-4 minthr-border-b minthr-border-b-3">
        <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
          <img className="minthr-icon-m" src="/icons/intervention.svg" alt="" />
        </div>
        <h3>{t('new.action')}</h3>

        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => {
            closeSidebar(NewActionIntervention);
          }}
        >
          <img src="/icons/close.svg" alt="" />
        </button>
      </div>
      <div className="form-details my-3 add-action">
        <div className="text-center text-danger error"></div>
        <Formik
          initialValues={{
            id: params.id,
            description: '',
          }}
          onSubmit={(values) => {
            handleAddStep(values);
          }}
          validationSchema={Yup.object().shape({
            description: Yup.string().trim().required(t('RequiredAttribute')),
          })}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="minthr-pt-2 minthr-flex minthr-flex-column">
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <TextArea
                      className=""
                      name="description"
                      label={t('Conge.Create.f.Remarque')}
                      rows={3}
                    ></TextArea>
                  </div>
                </div>
              </div>
              <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-py-4 minthr-mx-n5 minthr-px-4 minthr-mt-auto">
                <Button
                  type="submit"
                  loading={isSubmitting}
                  className="minthr-btn minthr-btn-primary minthr-ml-auto"
                >
                  {t('submit')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Sidebar>
  );
};

export default NewActionIntervention;
